import { trpc } from "@/util/trpc";
import { skipToken } from "@tanstack/react-query";

export const useAsset = ({ id, contentId }: { id?: number; contentId?: string }) => {
    const idOrAssetIdProvided = id != null || contentId != null;

    const query = trpc.edge.tokens.getSingle.useQuery(
        idOrAssetIdProvided
            ? {
                  id,
                  contentId,
              }
            : skipToken,
    );

    return {
        ...query,
        asset: query.data,
    };
};
